const validation = () => {
  return {
    email: (email) => {
      const pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      const result = pattern.test(email);
      return result;
    },

    passwordOnReg: (password) => {
        if(!password)
            return false
      const contains = {
        alphabets: 0,
        digits: 0,
        capitals: 0,
        specialChar: 0,
      };

      let isValidPassword = false
      const lengthOfPassword = password.length;
      for (let i = 0; i < lengthOfPassword; i++) {
        if(password[i]===' ')
            return isValidPassword;
        if (
          (password[i] >= "a" && password[i] <= "z") ||
          (password[i] >= "A" && password[i] <= "Z")
        ) {
          contains.alphabets += 1;
          if (password[i] >= "A" && password[i] <= "Z") contains.capitals += 1;
        }
      else if(password[i] >= "0" && password[i] <= "9")
        contains.digits+=1;
    else if(password[i]==='@' || password[i]==='_' || password[i]==='.' || password[i]==='-')
        contains.specialChar+=1;
    }

    if(contains.alphabets>=2 && contains.capitals>=1 && contains.alphabets-contains.capitals>=1 && contains.digits>=1 && contains.specialChar>=1)
        return true;
    
    return isValidPassword;

  },

  passwordOnLog: (password) =>{
      if(password && password.length>=5)
        return true
    return false;
  }

}};

export default validation;
